// src/features/bundles/hooks/use-update-bundle-status.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateBundleUsageStatus } from "../services/update-bundle-usage-status";

export function useUpdateBundleUsageStatus() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      bundle_id,
      status,
    }: {
      bundle_id: string;
      status: string;
    }) => updateBundleUsageStatus(bundle_id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      toast({
        title: "Success",
        description: "Bundle status updated successfully",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to update bundle status",
        variant: "destructive",
      });
    },
  });
}
